<template>
	<div>
		<div
			v-if="showLeagueHeader"
			class="title"
			:class="{'is-mobile': isMobileWebApp}"
		>
			{{ eventLeague.name }}
		</div>
		<Tab
			id="matchday-tabs"
			:tabs="tabs"
			small
		>
			<template #tabs-menu="{ selected, selectTab }">
				<ul
					v-if="tabs.length > 1"
					class="tabs-menu"
					data-qa="tabs"
				>
					<li
						v-for="tab in tabs"
						:key="`tab-${tab.key}`"
						class="tabs-menu__item"
						:class="{
							'active': tab.key === selected,
						}"
						@click="selectTab(tab.key)"
					>
						<div
							v-if="tab.label"
							class="tab-identity"
						>
							{{ tab.label }}
						</div>
					</li>
				</ul>
				<div
					v-else
					class="mt-4"
				/>
			</template>
			<template #above-tab-content>
				<EventBannerAd />
			</template>
			<template slot="tab-details-tab-0">
				<MatchdayList
					v-if="!isMatchdayLoading"
					:events="events"
					:no-events-today="noEventsToday"
					:event-league="eventLeague"
					@redirect-to-upcoming-event="(event) => $emit('redirect-to-upcoming-event', event)"
				/>
				<div
					v-else
					class="loading-spinner-w"
				>
					<LoadingSpinner
						class="loading-spinner"
					/>
				</div>
			</template>
			<template
				v-if="board.length"
				slot="tab-details-tab-1"
			>
				<ScoreTable
					:columns="columns"
					:teams="teams"
					:board="board"
				/>
			</template>
		</Tab>
	</div>
</template>

<script>
import Tab from '@components/tab';
import MatchdayList from '@components/MatchdayList';
import ScoreTable from '@components/ScoreTable';
import EventBannerAd from '@components/EventBannerAd';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { mapGetters } from 'vuex';

export default {
	name:       'Matchday',
	components: { Tab, MatchdayList, ScoreTable, LoadingSpinner, EventBannerAd },
	props:      {
		tabs: {
			type:    Array,
			default: () => [],
		},
		events: {
			type:    Array,
			default: () => [],
		},
		columns: {
			type:    Array,
			default: () => [],
		},
		teams: {
			type:    Object,
			default: () => {
			},
		},
		board: {
			type:    Array,
			default: () => [],
		},
		noEventsToday: {
			type:    String,
			default: 'There are no events scheduled for today',
		},
		eventLeague: {
			type:    Object,
			default: () => {},
		},
		isMatchdayLoading: {
			type:    Boolean,
			default: false,
		},
		showLeagueHeader: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.loader {
	padding: 24px 0;
}

.title {
	@include text-md-2;
	margin-left: 8px;

	&.is-mobile {
		margin-top: 12px;
	}
}

.divider {
	height: 1px;
	margin-left: 8px;
	margin-right: 8px;
	background: var(--color-grey-900);
}

.tabs-menu {
	margin-top: 12px;
	margin-bottom: 12px;

	&:not(.is-tagging-tool) {
		li {
			color: var(--color-grey-300);
			border-bottom: none;
			padding: 6px 16px 6px 16px;
			margin-right: 8px;
			border-radius: 2px;

			.tab-identity {
				display: flex;
				align-items: center;
				@include text-sm-2;

				.tab-icon {
					margin-right: 12px;
				}
			}

			&:hover:not(.active) {
				background: var(--color-grey-950);
			}
		}

		.active {
			color: var(--color-soft-white);
			background: var(--color-grey-900);

			body.-t-light & {
				background: var(--color-hype-yellow);
			}
		}
	}
}

.tabs-menu__item {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.loading-spinner-w {
	position: relative;
	min-height: 200px;
}

.loading-spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
